import {Component, inject} from '@angular/core';
import {News} from "../../models/news";
import {Subscription} from "rxjs";
import {NewsService} from "../../services/news.service";
import {ActivatedRoute} from "@angular/router";
import {ImageBase64ContentPipe} from "../../../core/pipes/image-base64-content.pipe";
import {DatePipe} from "@angular/common";
import {PageBase} from "../../../core/components/page-base";
import {getTranslation} from "../../../core/models/translatable-model-abstract";

@Component({
  selector: 'app-news-single',
  standalone: true,
  imports: [
    ImageBase64ContentPipe,
    DatePipe
  ],
  templateUrl: './news-single.component.html',
  styleUrl: './news-single.component.scss'
})
export class NewsSingleComponent extends PageBase {
  private newsService = inject(NewsService);
  private activatedRoute = inject(ActivatedRoute);

  protected news: News | null = null;
  protected slug: string = "";
  protected activatedRouteSubscription: Subscription = new Subscription();

  override ngOnInit(): void {
    this.activatedRouteSubscription = this.activatedRoute.params.subscribe(params => {
      this.activatedRouteSubscription = this.activatedRoute.params.subscribe(params => {
        this.slug = params['slug'];
        this.newsService.getBySlugFromApi(this.slug).subscribe({
            next: newsModel => {
              this.news = newsModel;

              this.pageTitle = getTranslation(this.news)?.seoTitle ? getTranslation(this.news)?.seoTitle : getTranslation(this.news).name;
              this.metaDescription = getTranslation(this.news)?.seoDescription;
              super.ngOnInit();
            },
          }
        );
      });
    });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.activatedRouteSubscription.unsubscribe();
  }

  protected readonly getTranslation = getTranslation;
}
